function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1_1224)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33 4H11V6H33V4Z",
  fill: "#860935"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.7 4.2L30.8 0.3C30.4 -0.1 29.7 -0.1 29.3 0.3C28.9 0.7 28.9 1.4 29.3 1.8L32.4 5L29.3 8.2C28.9 8.6 28.9 9.3 29.3 9.7C29.5 9.9 29.8 10 30.1 10C30.4 10 30.7 9.9 30.9 9.7L34.8 5.8C35.1 5.3 35.1 4.7 34.7 4.2Z",
  fill: "#860935"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.2 8H7V5C7 3.3 5.7 2 4 2C2.3 2 1 3.3 1 5V10C1 10.1 1 10.2 1 10.2C1.9 8.9 3.4 8 5.2 8Z",
  fill: "#B3B3B3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.5 16H29.9V25H30.5C31.3 25 32 24.3 32 23.5V17.5C32 16.7 31.3 16 30.5 16Z",
  fill: "#B3B3B3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.99995 13C2.89995 13 1.99995 12.5 1.49995 11.6C1.29995 12 1.19995 12.5 1.19995 13V25H28.5C27.7 25 27 24.3 27 23.5V17.5C27 16.7 27.7 16 28.5 16H28.7999V13C28.7999 10.8 27 9 24.7999 9H6.99995V10C6.99995 11.7 5.69995 13 3.99995 13Z",
  fill: "#B3B3B3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.5 11.6C2 12.5 2.9 13 4 13C5.7 13 7 11.7 7 10V9H5.2C3.5 9 2 10.1 1.5 11.6Z",
  fill: "#B3B3B3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27 17.5V23.5C27 24.3 27.7 25 28.5 25H28.8V16H28.5C27.7 16 27 16.7 27 17.5Z",
  fill: "#B3B3B3"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1_1224"
}, /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 26,
  fill: "white"
})));

function SvgSofaWidth({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 26,
    viewBox: "0 0 35 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAzNSAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzFfMTIyNCkiPgo8cGF0aCBkPSJNMzMgNEgxMVY2SDMzVjRaIiBmaWxsPSIjODYwOTM1Ii8+CjxwYXRoIGQ9Ik0zNC43IDQuMkwzMC44IDAuM0MzMC40IC0wLjEgMjkuNyAtMC4xIDI5LjMgMC4zQzI4LjkgMC43IDI4LjkgMS40IDI5LjMgMS44TDMyLjQgNUwyOS4zIDguMkMyOC45IDguNiAyOC45IDkuMyAyOS4zIDkuN0MyOS41IDkuOSAyOS44IDEwIDMwLjEgMTBDMzAuNCAxMCAzMC43IDkuOSAzMC45IDkuN0wzNC44IDUuOEMzNS4xIDUuMyAzNS4xIDQuNyAzNC43IDQuMloiIGZpbGw9IiM4NjA5MzUiLz4KPHBhdGggZD0iTTUuMiA4SDdWNUM3IDMuMyA1LjcgMiA0IDJDMi4zIDIgMSAzLjMgMSA1VjEwQzEgMTAuMSAxIDEwLjIgMSAxMC4yQzEuOSA4LjkgMy40IDggNS4yIDhaIiBmaWxsPSIjQjNCM0IzIi8+CjxwYXRoIGQ9Ik0zMC41IDE2SDI5LjlWMjVIMzAuNUMzMS4zIDI1IDMyIDI0LjMgMzIgMjMuNVYxNy41QzMyIDE2LjcgMzEuMyAxNiAzMC41IDE2WiIgZmlsbD0iI0IzQjNCMyIvPgo8cGF0aCBkPSJNMy45OTk5NSAxM0MyLjg5OTk1IDEzIDEuOTk5OTUgMTIuNSAxLjQ5OTk1IDExLjZDMS4yOTk5NSAxMiAxLjE5OTk1IDEyLjUgMS4xOTk5NSAxM1YyNUgyOC41QzI3LjcgMjUgMjcgMjQuMyAyNyAyMy41VjE3LjVDMjcgMTYuNyAyNy43IDE2IDI4LjUgMTZIMjguNzk5OVYxM0MyOC43OTk5IDEwLjggMjcgOSAyNC43OTk5IDlINi45OTk5NVYxMEM2Ljk5OTk1IDExLjcgNS42OTk5NSAxMyAzLjk5OTk1IDEzWiIgZmlsbD0iI0IzQjNCMyIvPgo8cGF0aCBkPSJNMS41IDExLjZDMiAxMi41IDIuOSAxMyA0IDEzQzUuNyAxMyA3IDExLjcgNyAxMFY5SDUuMkMzLjUgOSAyIDEwLjEgMS41IDExLjZaIiBmaWxsPSIjQjNCM0IzIi8+CjxwYXRoIGQ9Ik0yNyAxNy41VjIzLjVDMjcgMjQuMyAyNy43IDI1IDI4LjUgMjVIMjguOFYxNkgyOC41QzI3LjcgMTYgMjcgMTYuNyAyNyAxNy41WiIgZmlsbD0iI0IzQjNCMyIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzFfMTIyNCI+CjxyZWN0IHdpZHRoPSIzNSIgaGVpZ2h0PSIyNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgSofaWidth as ReactComponent };